





















import Vue, { PropType } from "vue"
import { NormalOption } from "~/clStores/profileSearchParameterOption"

export default Vue.extend({
  props: {
    value: {
      type: Number,
      default: undefined,
    },
    options: {
      type: Array as PropType<NormalOption[]>,
      required: true,
    },
  },
  methods: {
    isSelected(workingFormId: number): boolean {
      return this.value === workingFormId
    },
    handleInput(workingFormId: number) {
      // 選択中のオプションをクリックした場合、選択状態を解除する
      if (this.isSelected(workingFormId)) {
        this.$emit("input")
        return
      }

      this.$emit("input", workingFormId)
    },
  },
})
